import { css } from "@emotion/css";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export const neutralButtonStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    transitionTimingFunction: "ease-in-out",
    transitionProperty: "background-color, border-color, outline, color, fill",
    transitionDuration: "0.2s",
    borderRadius: borderRadius.small,
    paddingInlineStart: space[12],
    paddingInlineEnd: space[12],
    whiteSpace: "nowrap",
    color: themeTokens.color.button.text.neutral,
    background: themeTokens.color.button.background.neutral.default,
    font: text.body.bold.small,
    padding: space[6],
    border: "none",
    cursor: "pointer",
    width: "100%",
    svg: {
        fill: themeTokens.color.button.icon.neutral,
    },
    ":hover": {
        background: themeTokens.color.button.background.neutral.hover,
        color: themeTokens.color.button.text.neutral,
    },
    ":focus-visible": {
        background: themeTokens.color.button.background.neutral.hover,
    },
    ":active": {
        background: themeTokens.color.button.background.neutral.pressed,
        color: themeTokens.color.button.text.neutral,
    },
});
export const buttonLabelStyles = css({
    marginRight: space[4],
    marginLeft: space[4],
});
